var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v(" Edit News "),_c('v-text-field',{attrs:{"type":"number","label":"Display Limit"},model:{value:(_vm.config.limit),callback:function ($$v) {_vm.$set(_vm.config, "limit", $$v)},expression:"config.limit"}}),_c('v-btn',{on:{"click":_vm.save}},[_vm._v("Apply")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }